if (!customElements.get('tr-character-count')) {
	class TrCharacterCount extends HTMLElement {
		selectors = {
			input: 'textarea, input',
			remaining: '[data-tr-js-character-count-remaining]'
		};

		connectedCallback() {
			this.remainingElement = this.querySelector(this.selectors.remaining);
			this.inputElement = this.querySelector(this.selectors.input) || this.previousElementSibling;

			if (this.inputElement && !this.inputElement.matches?.(this.selectors.input)) {
				this.inputElement = null;
			}

			this.inputElement?.addEventListener('input', this.onInput);
			this.updateCount();
		}

		disconnectedCallback() {
			this.inputElement?.removeEventListener('input', this.onInput);
		}

		onInput = () => {
			this.updateCount();
		};

		updateCount() {
			if (!this.inputElement || !this.remainingElement) return;

			const maxLength = Number(this.inputElement.maxLength);

			if (!Number.isFinite(maxLength) || maxLength < 0) return;

			const remaining = Math.max(0, maxLength - this.inputElement.value.length);

			this.remainingElement.textContent = String(remaining);
		}
	}

	customElements.define('tr-character-count', TrCharacterCount);
}
